import { Icon } from '@aibees/shared/components';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo, useEffect } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ShowMoreButtonProps as Props } from './types';

export const ShowMoreButton = memo(({ className, onClick }: Props) => {
  const showMore = useBoolean();

  const handleShowMore = () => {
    showMore.setValue('toggle');
  };

  useEffect(() => {
    onClick?.(showMore.value);
  }, [showMore.value]);

  return (
    <Styled.Wrapper
      className={classnames('ShowMoreButton', className)}
      sx={SX.root}
      onClick={handleShowMore}
    >
      <Typography sx={SX.showMore}>
        {showMore.value ? 'Show Less' : 'Show More '}
      </Typography>

      <Icon
        name={showMore.value ? 'arrow-accordion-up' : 'arrow-accordion'}
        sxx={SX.showMoreIcon}
        size={16}
      />
    </Styled.Wrapper>
  );
});

ShowMoreButton.displayName = 'ShowMoreButton';
